export default "__VITE_ASSET__DG_B7Hd6__"